import searchIcon from './../../link-modal/images/search-icon.svg';
import closeIcon from './../../link-modal/images/close-icon.svg';
import loadingIcon from './../../link-modal/images/loading.svg';
const modalView = ({ searchPlaceholder }) => `
  <div class="link-modal-overlay">
    <div class="link-modal">
      <div class="link-modal__search">
        <div class="link-modal__search-field">
          <div class="link-modal__search-icon">${searchIcon}</div>
          <input type="text" class="link-modal__search-input" placeholder="${searchPlaceholder || 'Search job title'}..." autofocus />
        </div>

        <div class="link-modal__close">${closeIcon}</div>
      </div>
      <div class="link-modal__loading" style="display: none;">
        ${loadingIcon}
      </div>
      <div class="salaries-container">
        <div class="result"></div>
      </div>
      <strong class="selected-title">Selected items</strong>
      <div class="selected">
      </div>

      <div class="link-modal__footer">
        <div class="link-modal__footer-message">Press Esc to exit</div>
        <div><button class="ck ck-button ck-button-save">
        <svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"></path></svg>
        </button></div>
      </div>
    </div>
  </div>
`;
const salaryItem = (data) => {
    return `
      <div class="link-modal__publication salary_search_result">
        <div class="link-modal__publication-title">${data.title} - ${data.salary}</div>
      </div>
    `;
};
const selectedSalaryItem = (data) => {
    return `
  <div class="salaries_selected_salary">
    ${data.title} - ${data.salary}
  </div>
  `;
};
class SalariesModal {
    constructor(modalViewParams) {
        this.modalView = modalView(modalViewParams || {});
        this.selectedSalaries = [];
    }
    handleItemClick(salary) {
        if (!this.selectedSalaries.includes(salary)) {
            this.selectedSalaries.push(salary);
            this.selectedSalariesContainer.innerHTML = '';
            this.selectedSalaries.forEach((salary) => {
                // const selectedItem = selectedSkillItem(salary)
                this.selectedSalariesContainer.insertAdjacentHTML('beforeend', selectedSalaryItem(salary));
            });
            // document.querySelector('.closebtn').addEventListener('click', (e) => alert('click evnet'))
            this.salaries = [];
            this.salariesContainer.innerHTML = '';
        }
    }
    showSalaries(salaries, success = true) {
        this.salariesContainer.classList.add('is-visible');
        this.salariesContainer.innerHTML = salaryItem(salaries);
        if (success) {
            ;
            document.querySelector('.link-modal .ck-button').disabled = false;
            this.salariesContainer
                .querySelector('.salary_search_result')
                .addEventListener('click', () => {
                this.handleItemClick(salaries);
            });
        }
        else {
            ;
            document.querySelector('.link-modal .ck-button').disabled = true;
        }
    }
    show() {
        document.body.insertAdjacentHTML('afterbegin', this.modalView);
        document.body.style.overflowY = 'hidden';
        this.closeButton = document.querySelector('.link-modal__close');
        this.modalContainer = document.querySelector('.link-modal-overlay');
        this.salariesContainer = document.querySelector('.salaries-container');
        this.selectedSalariesContainer = document.querySelector('.selected');
        this.okButton = document.querySelector('.link-modal .ck-button');
        this.textField = document.querySelector('.link-modal__search-input');
        this.addHandlers();
        return new Promise((resolve, reject) => {
            this.onClickOk = resolve;
            this.onClose = reject;
        });
    }
    handleOkClick() {
        this.onClickOk(this.selectedSalaries);
        this.hide();
    }
    hide() {
        document.body.removeChild(this.modalContainer);
        document.body.style.overflowY = 'auto';
    }
    handleCloseClick(e) {
        e.stopPropagation();
        this.hide();
        // this.onClose()
    }
    handleEscapeClick(e) {
        if (e.code === 'Escape')
            this.handleCloseClick(e);
    }
    addHandlers() {
        let debounce;
        this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        this.modalContainer.addEventListener('keyup', this.handleEscapeClick.bind(this));
        this.textField.addEventListener('keyup', (e) => {
            clearTimeout(debounce);
            debounce = window.setTimeout(() => {
                this.handleTextFieldChange(e);
            }, 500);
        });
        this.okButton.addEventListener('click', this.handleOkClick.bind(this));
    }
    handleTextFieldChange(e) {
        const value = e.target.value.trim().toLowerCase();
        if (!value) {
            return;
        }
        const queryParams = new URLSearchParams({
            title: value,
        });
        const loadingIcon = document.querySelector('.link-modal__loading');
        loadingIcon.style.display = 'flex';
        // @TODO remove hardcoded api url
        fetch(`/api/career-data/v1/internal-salary-model?${queryParams}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
            if (!response.ok) {
                // check if there was JSON
                const contentType = response.headers.get('Content-Type');
                if (contentType && contentType.includes('application/json')) {
                    // return a rejected Promise that includes the JSON
                    return response.json().then((json) => Promise.reject(json));
                }
                // no JSON, just throw an error
                throw new Error('Something went wrong');
            }
            return response.json();
        })
            .then((data) => {
            this.salaries = data;
            this.showSalaries(this.salaries);
        })
            .catch(({ error }) => {
            console.table(error);
            this.showSalaries({ title: value, salary: 'NOT FOUND' }, false);
        })
            .finally(() => {
            // Hide loading icon
            ;
            loadingIcon.style.display = 'none';
        });
    }
}
export default SalariesModal;
